import React from 'react'
import GenericIcon from 'components/GenericIcon'

class IncomeHeader extends React.Component {
  render() {
    const { iconName, title } = this.props;

    return(
      <div className='media mt-1 mb-2'>
        <div className='media-image mr-3 align-self-top'>
          <GenericIcon name={ iconName } />
        </div>
        <div className='media-body'>
          { title }
        </div>
      </div>
    )
  }
}

export default IncomeHeader;
